import raz_assess_start from "../../../assets/raz/RazPoses_0001_lets_start.png";
import raz_assess_section from "../../../assets/raz/RazPoses_0000_sections.png";
import raz_assess_game from "../../../assets/raz/RazPoses_0002_lets_play.png";
import raz_quiz_time from "../../../assets/raz/RazPoses_0006_quiz_time.png";
import NUSWheel from "../../../assets/images/NUS_Wheel.png"
import React, {useEffect} from "react";
import BorderButton , {btnSize} from "../../../components/UI/BorderButton/BorderButton.ui";
import {getActiveThemeColor} from "../../../utils/utils";
import {useGlobalState} from "../../../context/global_state";
import Footer from "../../../components/Footer/plugable.footer";
import ReactHtmlParser from "react-html-parser";
import {GET_APP_LOCALIZE_TEXT} from "../../../utils/dq_lc_service/lc_service";
import {DQ_THEMES, LOCAL_STORAGE_KEYS} from "../../../utils/constants";
import styled from "styled-components";

// ── Section-page client-side copy ─────────────────────────────────────────────
// The section GUIDE step carries per-section DATA only (section_no, title,
// description, component names, question_count); repeated template text lives
// here on the client.

// Short blurbs per section component (Assess L4 name → one-liner). Components
// without an entry render with no blurb.
const SECTION_COMPONENT_DESCRIPTIONS = {
    'Digital Access at Home and School': 'Devices and internet you can use',
    'Youth AI-Digital Activities': 'What you do online',
    'Self-Regulated AI-Digital Engagement': 'Balancing your screen time',
    'Authentic and Ethical Digital Identity': 'How you show who you are online',
    'Digital Hygiene and Privacy Management': 'Keeping your info private and safe',
    'Critical Information Management': 'Telling what is true online',
    'Content Risk Avoidance': 'Handling upsetting content',
    'Contact Risk Avoidance': 'Dealing with strangers online',
    'Cyberbullying Management': 'Handling unkind behavior online',
    'Youth Perception of Home and Support Environment': 'Support from family and trusted adults',
    'Youth Perception of Parental Mediation': 'How parents guide your online use',
    'Youth Perception of School AI-Digital Literacy Education': 'What school teaches about digital life',
};

// Simple, neutral sans-serif for the CPCI section-intro card — deliberately not the
// theme-driven HeadingContainer/BodyContainer fonts (theme.fonts[2] "Lemon/Milk" is an
// all-caps-style display face; using it for body copy is what made the whole card read
// as shouty uppercase). Falls back through common system sans-serifs if Inter/Nunito
// Sans aren't loaded.
const NEUTRAL_FONT = '"Inter", "Nunito Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif';

// No "Note:" box on the section page — the dq-seal-client preview dropped it,
// and the backend now ends each section description with the same
// "This section contains N questions…" sentence the note repeated.

const GuidePoster = (props) => {

    const { locale, nextAction, prevAction, hasPreviousStep, title, description, raz_type, isCpci,
        section_no, components } = props;

    const { profile } = useGlobalState();

    useEffect(() => {
        // Never auto-skip the CPCI custom opening — it should always be shown once.
        if (isCpci) return;
        const skip_the_poster = localStorage.getItem(LOCAL_STORAGE_KEYS.SKIP_INTRO_POSTER_OF_QUIZ);
        if (skip_the_poster === 'true') {
            if (raz_type === 'raz_assess_start') {
                setTimeout(
                    () => {
                        localStorage.removeItem(LOCAL_STORAGE_KEYS.SKIP_INTRO_POSTER_OF_QUIZ);
                    }, 50
                );
                setTimeout(
                    () => {
                        nextAction();
                    }, 100
                );
            }
        }
    }, []);

    const getRazSrcByType = (r_type) => {
        switch (r_type) {
            case 'raz_assess_start':
                return raz_assess_start;
            case 'raz_assess_section':
                return raz_assess_section;
            case 'raz_assess_game':
                return raz_assess_game;
            case 'raz_quiz_time':
                return raz_quiz_time;
            default:
                return raz_assess_start;
        }
    }
    // const Theme = createTheme(settings.NUS_Theme);
    const Logo = styled.img`
        content: url(${props => {
            switch (props.theme.name) {
                case DQ_THEMES.DEFAULT:
                    return getRazSrcByType(raz_type, 'DQTheme');
                case DQ_THEMES.NUS_THEME:
                    return NUSWheel; 
                default:
                    return '';
            }
        }});
    `;

    const HeadingContainer = styled.div`
        font-family: ${(props) => {
            switch (props.theme.name) {
                case DQ_THEMES.DEFAULT:
                    return ` "${props.theme.fonts[2]}", "${props.theme.fonts[0]}", "${props.theme.fonts[1]}"` ;
                case DQ_THEMES.NUS_THEME:
                    return `"${props.theme.fonts[3]}"`;
                default:
                    return '';
            }
        }};
        font-weight: ${(props) => {
            switch (props.theme.name) {
                case DQ_THEMES.DEFAULT:
                    return 500;
                case DQ_THEMES.NUS_THEME:
                    return 900;
                default:
                    return 600;
            }
        }};
    `

    const BodyContainer = styled.div`
        font-family: ${(props) => {
            switch (props.theme.name) {
                case DQ_THEMES.DEFAULT:
                    return `"${props.theme.fonts[0]}", "${props.theme.fonts[1]}"` ;
                case DQ_THEMES.NUS_THEME:
                    return `"${props.theme.fonts[4]}"`;
                default:
                    return '';
            }
        }};
        font-weight: 600;
    `

    const accent = getActiveThemeColor(profile);

    // CPCI (Child Online Safety) — custom opening message shown at the start of
    // the assessment (i.e. any guide that isn't a per-section intro). UI mirrors
    // the dq-seal-client section intro, recoloured with this repo's theme colour.
    //
    // Note: this branch deliberately does NOT reuse the .qt-guide-heading /
    // .qt-guide-img-container / .qt-guide-body / .qt-cont-btn-container CSS
    // classes — those use an old float-column layout with a fixed 40vh image,
    // designed for a single short line of text, not this richer card content.
    // Building a self-contained card here avoids fighting that layout.
    // A section page that carries its section number gets this same card —
    // and so the Previous Section back button — whichever assessment it
    // belongs to (7 Oct 2026). It used to fall through to the older poster
    // below, which has Next only and no way back.
    if (raz_type === 'raz_assess_section' && (isCpci || section_no)) {
        const sectionComponents = Array.isArray(components) ? components : [];
        return (
            <div className={'qt-guide-container'} style={{ minHeight: 'auto', padding: '24px 16px 40px', marginTop: 'auto', marginBottom: 'auto' }}>
                {/* Plain div (not BodyContainer/HeadingContainer) — this card uses its own
                    neutral font set once here and inherited throughout, rather than the
                    theme-driven display font used by the rest of GuidePoster. Hierarchy is
                    built with size/weight only: Title > Section label > Body text > Note. */}
                <div style={{ maxWidth: 900, margin: '0 auto', width: '100%', textAlign: 'left', boxSizing: 'border-box', fontFamily: NEUTRAL_FONT }}>
                    {/* Header: number badge + title */}
                    <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 20 }}>
                        {section_no && (
                            <div style={{
                                width: 48, height: 48, borderRadius: 12, flexShrink: 0,
                                background: `${accent}1A`,
                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                            }}>
                                <span style={{ fontSize: 22, fontWeight: 800, color: accent }}>{section_no}</span>
                            </div>
                        )}
                        {/* Title */}
                        <div style={{ fontSize: 28, fontWeight: 800, color: '#111827', lineHeight: 1.25 }}>
                            {title}
                        </div>
                    </div>

                    {/* What you'll learn + section components */}
                    <div style={{
                        border: '1px solid #E5E7EB', borderRadius: 16, background: '#fff',
                        boxShadow: '0px 2px 12px rgba(0,0,0,0.05)', padding: '28px 32px', marginBottom: 20,
                    }}>
                        {/* Section label */}
                        <div style={{ fontSize: 13, fontWeight: 700, letterSpacing: '0.06em', textTransform: 'uppercase', color: '#6B7280', marginBottom: 8 }}>
                            What you'll learn
                        </div>
                        {/* Body text */}
                        {description && (
                            <p style={{ fontSize: 15.5, fontWeight: 400, lineHeight: 1.6, color: '#374151', textTransform: 'none', margin: '0 0 20px' }}>
                                {description}
                            </p>
                        )}

                        {sectionComponents.length > 0 && (
                            <>
                                <div style={{ height: 1, background: '#F3F4F6', marginBottom: 20 }} />

                                {/* Section label */}
                                <div style={{ fontSize: 13, fontWeight: 700, letterSpacing: '0.06em', textTransform: 'uppercase', color: '#6B7280', marginBottom: 14 }}>
                                    Section Components
                                </div>
                                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 12 }}>
                                    {sectionComponents.map((name) => (
                                        <div key={name} style={{ border: '1px solid #E5E7EB', borderRadius: 12, background: '#F9FAFB', padding: '14px 16px' }}>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
                                                <i className="fa fa-check" style={{ color: accent, fontSize: 14 }} />
                                                {/* Body text */}
                                                <span style={{ fontWeight: 600, fontSize: 15, color: '#111827', textTransform: 'none' }}>{name}</span>
                                            </div>
                                            {SECTION_COMPONENT_DESCRIPTIONS[name] && (
                                                <div style={{ fontSize: 13, fontWeight: 400, color: '#6B7280', lineHeight: 1.4, textTransform: 'none' }}>{SECTION_COMPONENT_DESCRIPTIONS[name]}</div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            </>
                        )}
                    </div>

                    {/* Back / Start Section — Back steps to the previous step (the
                        previous section's last question, or the opening poster
                        before section 1). */}
                    {/* Previous "Previous Section" variant (7 Oct 2026), kept for
                        possible reuse: same button, labelled "← Previous Section",
                        shown only when `hasPreviousSection` (section 2 onward) and
                        wired to `guidePrevSectionAction` in QuizTime.page.jsx
                        (commented out there):
                    <div style={{ display: 'flex', justifyContent: hasPreviousSection ? 'space-between' : 'flex-end', gap: 16 }}>
                        {hasPreviousSection && (
                            <button onClick={prevAction} style={...same as Back...}>
                                ← Previous Section
                            </button>
                        )}
                        ...Start Section button...
                    </div>
                    */}
                    <div style={{ display: 'flex', justifyContent: hasPreviousStep ? 'space-between' : 'flex-end', gap: 16, marginTop: 8 }}>
                        {hasPreviousStep && (
                            <button
                                onClick={prevAction}
                                style={{
                                    fontFamily: NEUTRAL_FONT,
                                    padding: '12px 28px', borderRadius: 10, background: '#fff',
                                    border: '1.5px solid #E5E7EB', color: '#6B7280', fontWeight: 700, fontSize: 15,
                                    cursor: 'pointer',
                                }}
                            >
                                ← Back
                            </button>
                        )}
                        <button
                            onClick={nextAction}
                            style={{
                                fontFamily: NEUTRAL_FONT,
                                padding: '12px 28px', borderRadius: 10, background: accent,
                                border: 'none', color: '#fff', fontWeight: 700, fontSize: 15,
                                cursor: 'pointer',
                            }}
                        >
                            Start Section →
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <>
            <div className={'qt-guide-container'} style={{minHeight:'auto !important'}}>
                <HeadingContainer
                    style={{color: getActiveThemeColor(profile)}}
                    className={'qt-guide-heading'} >
                    <span>{ReactHtmlParser(title)}</span>
                </HeadingContainer>
                <div className={'qt-guide-img-container'}>
                    <Logo className={'qt-guide-img'} ></Logo>
                    {/*<img className={'qt-guide-img'} src={getRazSrcByType(raz_type)} />*/}
                </div>
                <BodyContainer className={'qt-guide-body'}>
                    <span>{description && description.replace('This score', 'This test')}</span>
                    <div
                        className={'qt-cont-btn-container'}>
                        <BorderButton
                            size={btnSize.md}
                            title={GET_APP_LOCALIZE_TEXT(locale, 'result_quiz__next')}
                            action={nextAction}
                            themeColor={getActiveThemeColor(profile)}
                        />
                    </div>
                </BodyContainer>

            </div>

        </>
    )
};

export default GuidePoster;